module.exports = __webpack_public_path__ + "img/gift.a07f2686.png";